var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.74526 18H1.01339V5.98232H4.74526V18ZM2.87732 4.343C1.68399 4.343 0.716064 3.35458 0.716064 2.16125C0.716064 1.58805 0.943767 1.03833 1.34908 0.633017C1.75439 0.227703 2.30412 0 2.87732 0C3.45052 0 4.00024 0.227703 4.40556 0.633017C4.81087 1.03833 5.03857 1.58805 5.03857 2.16125C5.03857 3.35458 4.07025 4.343 2.87732 4.343ZM18.7124 18H14.9886V12.1499C14.9886 10.7556 14.9605 8.96766 13.0483 8.96766C11.1081 8.96766 10.8108 10.4824 10.8108 12.0494V18H7.0829V5.98232H10.6621V7.62164H10.7143C11.2125 6.67743 12.4296 5.68097 14.2453 5.68097C18.0222 5.68097 18.7165 8.16808 18.7165 11.3985V18H18.7124Z",
    fill: "#0089E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.eb9621f8447c28b51269794b6ec70082.svg";
export { ForwardRef as ReactComponent };